/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AppGoogleSSO_QueryVariables = {};
export type AppGoogleSSO_QueryResponse = {
    readonly viewer: {
        readonly actualPersonId: string | null;
        readonly component: string | null;
        readonly " $fragmentRefs": FragmentRefs<"AppGoogleSSO_viewer">;
    } | null;
};
export type AppGoogleSSO_Query = {
    readonly response: AppGoogleSSO_QueryResponse;
    readonly variables: AppGoogleSSO_QueryVariables;
};



/*
query AppGoogleSSO_Query {
  viewer {
    actualPersonId
    component(name: "app_google_sso")
    ...AppGoogleSSO_viewer
    id
  }
}

fragment AppGoogleSSO_viewer on Viewer {
  id
  company {
    id
    googleSSOEnabled
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "app_google_sso"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"app_google_sso\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppGoogleSSO_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AppGoogleSSO_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AppGoogleSSO_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "googleSSOEnabled",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "AppGoogleSSO_Query",
    "operationKind": "query",
    "text": "query AppGoogleSSO_Query {\n  viewer {\n    actualPersonId\n    component(name: \"app_google_sso\")\n    ...AppGoogleSSO_viewer\n    id\n  }\n}\n\nfragment AppGoogleSSO_viewer on Viewer {\n  id\n  company {\n    id\n    googleSSOEnabled\n  }\n}\n"
  }
};
})();
(node as any).hash = '7f779a860f7f49427950db91da08f5d7';
export default node;
